import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const MediaItem = styled.div`
  max-width: 200px;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  align-items: ${props => props.align === 'top' ? 'flex-start' : props.align === 'bottom' ? 'flex-end' : 'center'};
  
  @media (max-width: 767px) {
    margin-bottom: 2rem;
  }
`;

const MediaContainer = styled.div`
  display: flex;
  flex-direction: row;
  
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
  
  & + & {
    margin-top: 4rem;
  }
`;

export const Media = ({item, content, ...variants}) => {
  const classes = `flex ${variants.itemOn === 'left' ? 'flex-row ' : 'flex-row-reverse'}`;
  return (
    <MediaContainer className={classes}>
      <MediaItem {...variants}>
        {item}
      </MediaItem>
      <div className="flex-1 ml-8">
        {content}
      </div>
    </MediaContainer>
  );
};

Media.propTypes = {
  item: PropTypes.element.isRequired,
  content: PropTypes.element.isRequired,
  align: PropTypes.oneOf(['top', 'center', 'bottom']),
  itemOn: PropTypes.oneOf(['right', 'left']),
};

Media.defaultProps = {
  align: 'top',
  itemOn: 'left',
};



// WEBPACK FOOTER //
// ./src/components/Media.js